import { FC } from "react";
import { TButtonIconProps } from "./Button.config";
import { Icon } from "../Icon";

export const ButtonIcon: FC<TButtonIconProps> = ({ icon }) => (
  <>
    { icon ? (
      <div
        data-component="ButtonIcon"
        className="flex justify-center items-center w-4 h-4 flex-none"
      >
        <Icon icon={icon} size="sm" />
      </div>
    ): null }
  </>
);
